export type NotificationBody = {
  title: string
  description: string
  actionUrl: string | null
  actionLabel: string | null
}

function decodeEntities(value: string): string {
  return value
    .replaceAll("&quot;", '"')
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("&amp;", "&")
}

function innerText(html: string): string {
  return decodeEntities(html.replace(/<[^>]*>/g, "")).trim()
}

function firstTag(html: string, tag: string): string {
  const match = html.match(
    new RegExp(`<${tag}\\b[^>]*>([\\s\\S]*?)</${tag}>`, "i")
  )
  if (!match) return ""
  return innerText(match[1])
}

function firstAnchor(html: string): { href: string; label: string } | null {
  const match = html.match(
    /<a\b[^>]*href=["']([^"']*)["'][^>]*>([\s\S]*?)<\/a>/i
  )
  if (!match) return null

  const href = decodeEntities(match[1]).trim()
  if (!href) return null

  return { href, label: innerText(match[2]) }
}

export function parseNotificationBody(html: string): NotificationBody {
  const anchor = firstAnchor(html)

  return {
    title: firstTag(html, "h3"),
    description: firstTag(html, "p"),
    actionUrl: anchor?.href ?? null,
    actionLabel: anchor ? anchor.label : null
  }
}
